import { validate as isUUID } from 'uuid'
import { useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { StartForm } from './StartForm'

import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'
import { useCreateSessionEvent } from '../hooks/useCreateSessionEvent'

export const StartButton = () => {
  const [isOpen, setIsOpen] = useState(false)

  const getCurrentPage = useTechnicianPageStore(
    useShallow((state) => state.getCurrentPage),
  )

  const { createSessionEvent } = useCreateSessionEvent()

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger
        className="bg-primary-50 text-white px-10 py-2 rounded-full text-lg"
        data-testid="start-technician-mode-button"
      >
        Start
      </DialogTrigger>
      <DialogContent ariaLabel="Technician mode" className="gap-0">
        <DialogHeader className="space-y-0">
          <DialogTitle className="text-center">
            Technician Acknowledgement
          </DialogTitle>
          <DialogDescription className="text-left max-w-[550px] self-center justify-self-center pt-4">
            Please enter your name to confirm that you have reviewed and
            understood all work instructions before proceeding. This step
            ensures accountability and traceability for compliance and quality
            control.
          </DialogDescription>
        </DialogHeader>

        <div className="w-full my-0">
          <StartForm
            onStart={() => {
              setTimeout(() => {
                const currentPageId = getCurrentPage()
                if (currentPageId && isUUID(currentPageId)) {
                  void createSessionEvent({
                    documentPageId: currentPageId,
                    buttonLabel: 'Complete',
                  })
                }
              }, 0)
              setIsOpen(false)
            }}
            onCancel={() => {
              setIsOpen(false)
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
